class RoomSingleton {
    constructor() {
        this._roomId = '';
        this._bazarState = 0;
        this._playState = 0;
        this._announceState = 0;
    }

    reset() {
        this._roomId = '';
        this._bazarState = 0;
        this._playState = 0;
        this._announceState = 0;
    }

    set roomId(_roomId) {
        this._roomId = _roomId;
    }

    get roomId() {
        return this._roomId;
    }

    set bazarState(_bazarState) {
        this._bazarState = _bazarState;
    }

    get bazarState() {
        return this._bazarState;
    }

    set playState(_playState) {
        this._playState = _playState;
    }

    get playState() {
        return this._playState;
    }
    set announceState(_announceState) {
        this._announceState = _announceState;
    }

    get announceState() {
        return this._announceState;
    }
}

export default new RoomSingleton();
